import { bootstrapApplication, disableDebugTools } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from '@environments/crowndesk/environment';
import { enableProdMode } from '@angular/core';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentry,
  environment: environment.name,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

  tracesSampleRate: 1.0,

  tracePropagationTargets: ['localhost', /^https:\/\/prod\.crownbasenxt\.be/, /^https:\/\/staging\.crownbasenxt\.be/],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    if (!environment.production) {
      enableProdMode();
    } else {
      disableDebugTools();
    }
  })
  .catch((err) => console.error(err));
